/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGovernmentPeople = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 8a1 1 0 0 0 .447-1.895l-10-5a1 1 0 0 0-.787-.045l-.108.045-10 5A1 1 0 0 0 2 8zM12 3.118 17.763 6H6.236zM5 10H3v9h2zm4 0H7v9h2zm4 9v-9h-2v9zm5-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-3 8a3 3 0 0 1 6 0h2a5 5 0 0 0-10 0zm-4-2H1v2h10z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGovernmentPeople as GovernmentPeople };
